import { useRoles } from '@zorro/web/ui-utils';

import {
  CompanyDetailsFormInputs,
  useCompanyDetailsForm,
} from '../../CompanyDetailsForm';
import {
  CompanySetupTabType,
  CompanySetupTabWrapper,
} from '../CompanySetupTabWrapper';

const isFinalizationMode = true;
const isNaicsCodeVisible = true;

type Props = {
  employerId: string;
  isDon: boolean;
};

export const CompanyDetailsSetupTab = ({ employerId, isDon }: Props) => {
  const { isZorroOperations } = useRoles();
  const isSignedAgreementVisible = !isDon && isZorroOperations;

  const {
    companyDetailsForm,
    onSubmit,
    setHasLogoBeenDeleted,
    hasLogoBeenDeleted,
    isSignedAgreementRequired,
    isLynxPaymentsEnabled,
  } = useCompanyDetailsForm({
    employerId,
    isDon,
    isFinalizationMode,
    isSignedAgreementVisible,
  });

  const { formState } = companyDetailsForm;

  const handleSubmit = async () => Boolean(await onSubmit());

  return (
    <CompanySetupTabWrapper
      onCancel={() => {
        companyDetailsForm.reset();
        setHasLogoBeenDeleted(false);
      }}
      tab={CompanySetupTabType.COMPANY_DETAILS}
      employerId={employerId}
      onSubmit={handleSubmit}
      formState={formState}
      isDon={isDon}
    >
      <CompanyDetailsFormInputs
        isFinalizationMode={isFinalizationMode}
        isSignedAgreementVisible={isSignedAgreementVisible}
        isSignedAgreementRequired={isSignedAgreementRequired}
        companyDetailsForm={companyDetailsForm}
        setHasLogoBeenDeleted={setHasLogoBeenDeleted}
        hasLogoBeenDeleted={hasLogoBeenDeleted}
        isNaicsCodeVisible={isNaicsCodeVisible}
        isLynxPaymentsEnabled={isLynxPaymentsEnabled}
      />
    </CompanySetupTabWrapper>
  );
};
